var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chemical-latex',_vm._g(_vm._b({attrs:{"content":_vm.computedValue}},'chemical-latex',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }